import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  containerButtons: {
    margin: '0px 5px 0px 5px',
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    flexDirection: 'row',
  },
  confirm: {
    margin: '0px 5px 0px 1px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    color: '#BC0000',
    borderColor: '#BC0000',
    lineHeight: '22px',
    height: '28px',
    letterSpacing: '0.46px',
    padding: '0px 5px 0px 5px',
    border: '1px solid',
  },
  deny: {
    color: '#347F42',
    borderColor: '#347F42',
    lineHeight: '22px',
    height: '28px',
    letterSpacing: '0.46px',
    padding: '0px 5px 0px 5px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '12px',
    border: '1px solid',
  },
}));
